var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"a-title"},[_c('img',{attrs:{"src":require("@/assets/memocard-white.svg"),"alt":"MemoCard"}})])}
var staticRenderFns = []

export { render, staticRenderFns }